import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import AdminMenu from "./AdminMenu";
import PageHeader from "../components/PageCloseButton";
import FormatPrice from '../Helpers/FormatPrice'

const UserDetails = ({ data }) => {
  const [sortOrder, setSortOrder] = useState("asc");
  if (!data || !data.user) return <p>No user data found</p>;

const { user, orders } = data;
 
 // Sort orders by date
    const sortedOrders = [...orders].sort((a, b) => {
      const dateA = moment(a.createdAt).valueOf();
      const dateB = moment(b.createdAt).valueOf();
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    }); 

  return (
    <Wrapper>
      <div className="grid grid-two-column">
            <AdminMenu />
        <div className="main-container">
          <PageHeader title="User Info" /> 
          
          {/* Profile */}
            <div className="profile-detail">
              <div className="profile-card">
              <img
                src={user.profile || "/default-avatar.png"}
                alt={user.name || user.username}
                className="profile-image"
              />
              <div>
                <h2>{user.name || "N/A"}</h2>
                <p>Id-{user.username}</p>
                <span className="role-badge">{user.role?.toUpperCase()}</span>
              </div>
            </div>

          {/* Info */}
        <div className="info-card">
            <h3>Profil Details</h3>
            <div className="info-grid">
              <div><label>Company</label><p>{user.company || "N/A"}</p></div>
              <div><label>Email</label><p>{user.email || "N/A"}</p></div>
              <div><label>Business Type</label><p>{user.businesstype || "N/A"}</p></div>
              <div><label>Mobile</label><p>(+{user.isdCode}) - {user.mobile || "N/A"}</p></div>
              <div><label>Country</label><p>{user.country || "N/A"}</p></div>
            </div>
        </div>
      
            </div>

          {/* Orders */}
            <div className="orders-section">
              <h3>Order History</h3>
              <div className="order-container">
                {orders.length === 0 ? (
                  <p>No orders found</p>
                ) : (
                
                <table className="table-container">
                  <thead>
                    <tr>
                      <th onClick={() =>
                      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                      }
                      style={{ cursor: "pointer" }}
                      >
                      Date {sortOrder === "asc" ? "▲" : "▼"}</th>
                      <th>Order No</th>
                      <th>Amount</th> 
                      <th>Payment</th>
                      <th>Status</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {sortedOrders.map((order) => (
                      <tr key={order._id}>
                        <td>{moment(order.createdAt).format("DD/MM/YYYY")}</td>
                        <td><NavLink to={`/orderprint/${order._id}`}>{order.orderNumber}</NavLink></td>
                        <td><FormatPrice price={order.orderTotal} /></td>
                        <td>{order.payment}</td>
                        <td> <span className={`status ${order.status}`}>
                          {order.status}
                          </span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              </div>
            </div>
        </div>
      </div>
    </Wrapper>
    );
  };

const Wrapper = styled.div`

.grid-two-column{
      display: grid;
      grid-template-columns: 2fr 8fr;
      gap: 2rem;
      }
 
 .main-container{
      padding: 2rem;   
      }

.profile-detail{
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  background-color:#fff;
  border: 1px solid grey;
  border-radius: 10px;
  }

  .profile-card {
   display: flex;
   gap: 2rem;
   padding: 2rem;
  }

  h2 {
   font-size: 2rem; 
   margin:  1.5rem 0;
  }

  .profile-image {
   width: 7rem;
   height: 7rem;
   border-radius: 50%;
   }
 
  .info-card {
    padding : 1rem;
    margin-top: 1rem;
    }

.info-grid {
   margin-top:2rem;
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 1.5rem;
   }

  h3
  {margin:  1.5rem 0;
  }

  
.orders-section{
  width: 100%;
  }

.order-container {
    max-height: 400px; /* adjust as needed */
    overflow-y: auto;
    border: 1px solid #ddd;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    }

table {
    margin:2rem ;
    width: 97%;
    border-collapse: collapse;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);     
 }

thead {
      background-color: ${({ theme }) => theme.colors.font};
      color: #fff;
    }

  thead th {
      position: sticky;
      top: 0;
      padding: 12px;
      font-size: 14px;
      text-align: left;
      letter-spacing: 0.5px;
      z-index: 2;
      }

  tbody tr {
      border-bottom: 1px solid #eee;
      transition: 0.2s ease;
      }

  tbody tr:hover {
    background-color: #f9f9f9;
    }

  td {
    padding: 12px;
    font-size: 14px;
    vertical-align: top;
    }
 
.pending {
    color: #856404;
    }

  .ProformaSend {
    color: #9333ea;
    }

  .Processing {   
    color: #2563eb;
    }

  .Shipped{
    color: #eab308;
    }

  .Docs-emailed
    { color: #0d9488;
    }

   .Delivered {
      color: #155724;
      }
    
    .Cancelled {
      color: #dc2626;
      }


@media (max-width: ${({ theme }) => theme.media.mobile}) {

.grid-two-column {
  grid-template-columns: 1fr;
  }

.profile-detail{
  display: block;
  }
 
.info-grid {
  margin-top:2rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
  }


table, thead, tbody, th, td, tr {
      display: block; 
      width: 100%;
    }

table {
    width: 95%;
    }

  thead {
      display: none;
      }

  tr {
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      padding: 0.2rem;
      border-radius: 6px;
      }

  td {
      border: none;
      position: relative;
       padding: 0.5rem 0.5rem 0.5rem 1rem;
      }

  td::before {
      position: absolute;
      left: 0.2rem;
      font-weight: bold;
      content: attr(data-label); 
      }
    }
`;

export default UserDetails;